const Emoji_W = {
    ':w00t': { id: 538, width: 20, height: 21 },
    ':w00t1': { id: 536, width: 28, height: 28 },
    ':w00t2': { id: 537, width: 28, height: 28 },
    ':wacko': { id: 539, width: 20, height: 20 },
    ':wallbash': { id: 540, width: 30, height: 23 },
    ':wassat': { id: 541, width: 18, height: 18 },
    ':watsup': { id: 542, width: 20, height: 21 },
    ':wave': { id: 139, width: 26, height: 18 },
    ':weep': { id: 543, width: 21, height: 15 },
    ':weight_lift': { id: 545, width: 35, height: 21 },
    ':weight_lift2': { id: 544, width: 32, height: 18 },
    ':whateverdood': { id: 590, width: 23, height: 25 },
    ':whatsthat': { id: 546, width: 20, height: 18 },
    ':wheelchair': { id: 547, width: 29, height: 31 },
    ':whistle': { id: 28, width: 28, height: 18 },
    ':whistlesmile': { id: 548, width: 24, height: 24 },
    ':whistling': { id: 613, width: 28, height: 18 },
    ':wiggle': { id: 549, width: 32, height: 27 },
    ':wince': { id: 30, width: 18, height: 18 },
    ':wink_1': { id: 550, width: 18, height: 18 },
    ':wink_2': { id: 551, width: 18, height: 18 },
    ':wink_3': { id: 552, width: 20, height: 20 },
    ':wink_5': { id: 553, width: 18, height: 18 },
    ':wink_6': { id: 554, width: 18, height: 18 },
    ':wink_7': { id: 555, width: 20, height: 20 },
    ':wink': { id: 556, width: 20, height: 20 },
    ':wolfwood': { id: 557, width: 31, height: 31 },
    ':wolverine': { id: 559, width: 20, height: 20 },
    ':wolverine2': { id: 558, width: 26, height: 26 },
    ':wounded1': { id: 560, width: 18, height: 18 },
    ':wounded2': { id: 561, width: 18, height: 18 },
    ':wow': { id: 5, width: 18, height: 18 },
    ':wub': { id: 563, width: 22, height: 29 },
    ':wub2': { id: 562, width: 22, height: 29 },
}

export default Emoji_W
